import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import KPICard from '../../components/shared/KPICard';
import SectionDivider from '../../components/shared/SectionDivider';
import { gujaratDISCOMs, pgvclCircles } from '../../data/mockData';

export default function StateDistricts() {
  const [expandedDISCOM, setExpandedDISCOM] = useState<string | null>(null);

  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="DISCOMs" value="4" subtext="PGVCL, MGVCL, DGVCL, UGVCL" />
        <KPICard title="Districts" value="33" subtext="All covered" />
        <KPICard title="Total Plants" value="6,240" subtext="Gujarat" />
        <KPICard title="Avg PR" value="78.2%" subtextColor="green" subtext="Good zone" />
      </div>

      <div className="bg-white rounded-card border border-border shadow-card p-4">
        <SectionDivider title="DISCOM Performance — Gujarat" subtitle="Click row to see circle breakdown" />
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2.5 text-text-tertiary font-medium">DISCOM</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Plants</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Capacity GWp</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">GWh Today</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">PR%</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Active%</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Alarms</th>
            </tr>
          </thead>
          <tbody>
            {gujaratDISCOMs.map(discom => (
              <React.Fragment key={discom.id}>
                <tr
                  className={`border-b border-border/50 cursor-pointer hover:bg-bg-secondary transition-colors ${expandedDISCOM === discom.id ? 'bg-bg-tertiary' : ''}`}
                  onClick={() => setExpandedDISCOM(prev => prev === discom.id ? null : discom.id)}
                >
                  <td className="py-2.5">
                    <div className="flex items-center gap-2">
                      {expandedDISCOM === discom.id
                        ? <ChevronUp size={12} className="text-accent" />
                        : <ChevronDown size={12} className="text-text-tertiary" />}
                      <span className="font-medium text-accent">{discom.name}</span>
                    </div>
                  </td>
                  <td className="py-2.5 text-right text-text-secondary">{discom.plants.toLocaleString()}</td>
                  <td className="py-2.5 text-right text-text-secondary">{discom.capacityGWp.toFixed(2)}</td>
                  <td className="py-2.5 text-right font-medium text-text-primary">{discom.generationGWh.toFixed(2)}</td>
                  <td className={`py-2.5 text-right font-semibold ${discom.prPercent >= 75 ? 'text-success' : 'text-warning'}`}>{discom.prPercent.toFixed(1)}%</td>
                  <td className="py-2.5 text-right text-text-secondary">{discom.activePercent.toFixed(0)}%</td>
                  <td className="py-2.5 text-right text-text-secondary">{discom.alarms}</td>
                </tr>

                {expandedDISCOM === discom.id && (
                  <tr>
                    <td colSpan={7} className="p-0">
                      <div className="bg-bg-secondary px-6 py-4 border-b border-border">
                        <p className="text-xs text-text-secondary mb-2">Circle breakdown — {discom.name}</p>
                        <table className="w-full text-xs bg-white rounded-input border border-border overflow-hidden">
                          <thead>
                            <tr className="bg-bg-tertiary border-b border-border">
                              <th className="text-left py-2 px-3 text-text-tertiary font-medium">Circle</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">Plants</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">MWh Today</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">PR%</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">Active%</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">MTTR (h)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pgvclCircles.map(circle => (
                              <tr key={circle.id} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                                <td className="py-2 px-3 font-medium text-text-primary">{circle.name}</td>
                                <td className="py-2 px-3 text-right text-text-secondary">{circle.plants}</td>
                                <td className="py-2 px-3 text-right font-medium">{circle.generationMWh.toLocaleString()}</td>
                                <td className={`py-2 px-3 text-right font-semibold ${circle.prPercent >= 75 ? 'text-success' : 'text-warning'}`}>{circle.prPercent}%</td>
                                <td className="py-2 px-3 text-right text-text-secondary">{circle.activePercent}%</td>
                                <td className="py-2 px-3 text-right text-text-secondary">{circle.mttrHours}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
